import styled from 'styled-components';

export const Cell = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: relative;
  &:not(:last-child):before {
    content: '';
    width: 1px;
    height: 60%;
    background: rgba(0, 0, 0, .1);
    position: absolute;
    right: 0;
  }
`;

export const MonthDay = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, .8);
  font-size: 10px;
  font-weight: 500;
  width: 100%;
  height: 60%;
`;

